import React, {useState} from 'react';

import * as S from './InfoEditPop.styles';

const InfoEditPop = ({closePop, userData, newUserData}) => {
  const [
    {
      company_name,
      secondary_mobile,
      secondary_email,
      company_address,
      city,
      state,
      pincode,
      business_type,
    },
    setUserInfo,
  ] = useState({
    company_name: userData.company_name ? userData.company_name.value : '',
    secondary_email: userData.secondary_email ? userData.secondary_email.value : '',
    secondary_mobile: userData.secondary_mobile ? userData.secondary_mobile.value : '',
    company_address: userData.company_address ? userData.company_address.value : '',
    city: userData.city ? userData.city.value : '',
    state: userData.state ? userData.state.value : '',
    pincode: userData.pincode ? userData.pincode.value : '',
    business_type: userData.business_type ? userData.business_type.value : '',
  });

  const onChangeHandler = (field, value) => {
    const data = {
      company_name,
      secondary_email,
      secondary_mobile,
      company_address,
      city,
      state,
      pincode,
      business_type,
    };
    data[field] = value;
    setUserInfo(data);
  };

  const submitUserInfo = (event: React.FormEvent) => {
    event.preventDefault();
    const data = {
      company_name,
      secondary_email,
      secondary_mobile,
      company_address,
      city,
      state,
      pincode,
      business_type,
    };
    // const hasError = validateFields(data);
    newUserData(data);
  };

  return (
    <S.PopOverlayWrap>
      <S.PopContentWrap>
        <S.PopHeaderWrap>
          <S.PopHeadTex>Edit Company Details</S.PopHeadTex>
        </S.PopHeaderWrap>
        <S.PopBodyWrap>
          <S.UserInfoForm onSubmit={submitUserInfo}>
            <S.UserOptionWrap>
              <S.UserOptionInnerMultiWrap>
                <S.CommonLabel>Company Name</S.CommonLabel>
                <S.CommonInput
                  disabled={true}
                  type="text"
                  placeholder="Enter Company Name"
                  onChange={event => onChangeHandler('company_name', event.target.value)}
                  value={company_name}
                />
              </S.UserOptionInnerMultiWrap>

              <S.UserOptionInnerMultiWrap>
                <S.CommonLabel>Business Type</S.CommonLabel>
                <S.CommonSelect
                  disabled={true}
                  value={business_type}
                  onChange={event => onChangeHandler('business_type', event.target.value)}
                >
                  <option value="Employee">Employee</option>
                  <option value="HUF">HUF</option>
                  <option value="Joint Venture">Joint Venture</option>
                  <option value="Limited">Limited</option>
                  <option value="Partnership">Partnership</option>
                  <option value="Private Limited Company">Private Limited Company</option>
                  <option value="Sole Proprietership">Sole Proprietership</option>
                </S.CommonSelect>
              </S.UserOptionInnerMultiWrap>
            </S.UserOptionWrap>

            <S.UserOptionWrap>
              <S.UserOptionInnerWrap>
                <S.CommonLabel>Company Address</S.CommonLabel>
                <S.CommonInput
                  disabled={!userData.company_address.is_editable}
                  type="text"
                  placeholder="Enter Company address"
                  onChange={event => onChangeHandler('company_address', event.target.value)}
                  value={company_address}
                />
              </S.UserOptionInnerWrap>
            </S.UserOptionWrap>

            <S.UserOptionWrap>
              <S.UserOptionThreeWrap>
                <S.CommonLabel>City</S.CommonLabel>
                <S.CommonInput
                  disabled={!userData.city.is_editable}
                  type="text"
                  placeholder="Enter City"
                  onChange={event => onChangeHandler('city', event.target.value)}
                  value={city}
                />
              </S.UserOptionThreeWrap>

              <S.UserOptionThreeWrap>
                <S.CommonLabel>State</S.CommonLabel>
                <S.CommonInput
                  disabled={!userData.state.is_editable}
                  type="text"
                  placeholder="Enter State"
                  onChange={event => onChangeHandler('state', event.target.value)}
                  value={state}
                />
              </S.UserOptionThreeWrap>

              <S.UserOptionThreeWrap>
                <S.CommonLabel>Pincode</S.CommonLabel>
                <S.CommonInput
                  disabled={!userData.pincode.is_editable}
                  type="text"
                  placeholder="Enter Pincode"
                  onChange={event => onChangeHandler('pincode', event.target.value)}
                  value={pincode}
                />
              </S.UserOptionThreeWrap>
            </S.UserOptionWrap>

            {/* <S.UserOptionWrap>
              <S.UserOptionInnerWrap>
                <S.CommonLabel>Secondry Email ID</S.CommonLabel>
                <S.CommonInput
                  disabled={!userData.secondary_email.is_editable}
                  type="text" 
                  placeholder="Enter Secondary Email Id" 
                  onChange={event => onChangeHandler('secondary_email', event.target.value)}
                  value={secondary_email}   
                />
              </S.UserOptionInnerWrap>
            </S.UserOptionWrap> */}

            <S.UserOptionWrap>
              <S.UserOptionInnerWrap>
                <S.CommonLabel>Secondary Mobile Number</S.CommonLabel>
                <S.CommonInput
                  disabled={!userData.secondary_mobile.is_editable}
                  type="text"
                  placeholder="Enter Secondary Mobile Number"
                  onChange={event => onChangeHandler('secondary_mobile', event.target.value)}
                  value={secondary_mobile}
                />
              </S.UserOptionInnerWrap>
            </S.UserOptionWrap>

            <S.ButtonOptionWrap>
              <S.CancelBtn onClick={closePop}>Cancel</S.CancelBtn>
              <S.SaveBtn type="submit">SAVE</S.SaveBtn>
            </S.ButtonOptionWrap>
          </S.UserInfoForm>
        </S.PopBodyWrap>
      </S.PopContentWrap>
    </S.PopOverlayWrap>
  );
};

export default InfoEditPop;
